module.exports = __webpack_public_path__ + "static/media/box-usd.86657967.svg";